import { reducers } from "./store";
import thunkMiddleware from "redux-thunk";
import promiseMiddleware from "redux-promise-middleware";
import { applyMiddleware, createStore } from 'redux';



const authState = {
	auth: {
		pending: false,
		sid: localStorage.getItem( 'sid' ) || null,
		token: localStorage.getItem( 'token' ) || null,
		authenticated: false,
	},
};

const store = applyMiddleware(
	thunkMiddleware,
	promiseMiddleware,
)( createStore )( reducers, authState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() );


export default store;